import React, { useState, useEffect } from 'react';
import '../styles/Dashboard.css';
import ContactImport from './ContactImport';
import GraphSearch from './GraphSearch';
import Requests from './Requests';
import MyNetwork from './MyNetwork';
import Profile from './Profile';
import CompanyConsole from './CompanyConsole';

function Dashboard({ user, onLogout, onUserUpdate }) {
  const [activeTab, setActiveTab] = useState('search'); // 'search', 'requests', 'network', 'contacts', 'profile'
  const profileIncomplete = user && (!user.employer || !user.industry);

  return (
    <div className="dashboard-container">
      <nav className="dashboard-nav">
        <div className="user-info">
          <div className="user-avatar">{user?.name?.[0]?.toUpperCase()}</div>
          <div>
            <p className="user-name">{user?.name}</p>
            <p className="user-email">{user?.email}</p>
          </div>
        </div>
        <button className="btn btn-logout" onClick={onLogout}>
          Logout
        </button>
      </nav>

      <div className="dashboard-content">
        <header className="dashboard-header">
          <h2>Your Trust Network</h2>
          <p>Discover verified connections through mutual trust</p>
        </header>

        {profileIncomplete && activeTab !== 'profile' && (
          <div className="profile-banner">
            <span>Complete your profile — add your employer and industry so your links can place you.</span>
            <button type="button" onClick={() => setActiveTab('profile')}>Complete profile</button>
          </div>
        )}

        <div className="tabs">
          <button
            className={`tab ${activeTab === 'search' ? 'active' : ''}`}
            onClick={() => setActiveTab('search')}
          >
            🔍 Search
          </button>
          <button
            className={`tab ${activeTab === 'requests' ? 'active' : ''}`}
            onClick={() => setActiveTab('requests')}
          >
            ✉️ Requests
          </button>
          <button
            className={`tab ${activeTab === 'network' ? 'active' : ''}`}
            onClick={() => setActiveTab('network')}
          >
            🔗 My Network
          </button>
          <button
            className={`tab ${activeTab === 'contacts' ? 'active' : ''}`}
            onClick={() => setActiveTab('contacts')}
          >
            👥 Contacts
          </button>
          <button
            className={`tab ${activeTab === 'company' ? 'active' : ''}`}
            onClick={() => setActiveTab('company')}
          >
            🏢 Company
          </button>
          <button
            className={`tab ${activeTab === 'profile' ? 'active' : ''}`}
            onClick={() => setActiveTab('profile')}
          >
            🙂 Profile
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'search' && (
            <GraphSearch />
          )}

          {activeTab === 'requests' && (
            <Requests />
          )}

          {activeTab === 'network' && (
            <MyNetwork />
          )}

          {activeTab === 'contacts' && (
            <ContactImport userId={user?.id} />
          )}

          {activeTab === 'company' && (
            <CompanyConsole />
          )}

          {activeTab === 'profile' && (
            <Profile user={user} onUserUpdate={onUserUpdate} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
